<template>
  <v-list class="user-card pa-0">
    <v-list-tile avatar v-if="alreadySent">
      <v-list-tile-avatar color="grey" size="24">
        <img
          alt="Avatar"
          :src="folder.current_owner.avatar.url"
          v-if="folder.current_owner.avatar.url"
        >
        <span class="caption" v-else>{{ acronym(folder.current_owner.name) }}</span>
      </v-list-tile-avatar>

      <v-tooltip top>
        <v-list-tile-content slot="activator">
          <v-list-tile-title class="body-1">{{ shortName(folder.current_owner.name) }}</v-list-tile-title>
          <v-list-tile-sub-title
              class="caption tooltip"
          >{{ folder.current_owner.role.name }}</v-list-tile-sub-title>
        </v-list-tile-content>
        <span>{{folder.current_owner.administrative_unit.name}}</span> <br>
        <span>{{folder.current_owner.role.name}}</span>
      </v-tooltip>

    </v-list-tile>
    <v-list-tile v-else>
      <v-chip color="grey-lighten-2">
        Não Tramitado
      </v-chip>
    </v-list-tile>
  </v-list>
</template>

<script>
import acronym from '@/utils/acronym';
import shortName from '@/utils/short-name';
import { isNull } from 'lodash';

export default {
  name: 'current-owner',
  props: ['folder'],
  data() {
    return {
      shortName,
    };
  },
  methods: {
    acronym(string) {
      return acronym(string);
    },
    alreadySent() {
      return !isNull(this.folder.last_transaction);
    },
  },
  computed: {
    folderNotReceivedClass() {
      if (this.folder.current_owner.id === this.user.id) {
        return 'folder-received';
      }
      return '';
    },
    user() {
      return this.$store.getters.user;
    },
  },
};
</script>
<style scoped>
.tooltip {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 20ch;
  white-space: nowrap;
}

  .folder-received {
    background: #f2f2f2 !important;
  }

  .user-card {
    background: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/inbox/CurrentOwner.vue